<template>
  <!-- eslint-disable-next-line vue/no-v-html -->
  <p v-if="cguText" v-html="cguText" />
  <p v-else-if="issue">
    {{ $t(issue) }}
  </p>
</template>

<script>
  import { CguService } from "@core/services/cgu.service";

  export default {
    name: "CGU",
    data() {
      return {
        cguText: null,
        issue: null,
      };
    },
    created() {
      this.getCgu();
    },
    methods: {
      async getCgu() {
        try {
          this.$_startGlobalLoading();
          this.cguText = await CguService.cguText();
        } catch (error) {
          this.issue = "ERRORS.@PLEASE_TRY_AGAIN";
          throw error;
        } finally {
          this.$_stopGlobalLoading();
        }
      },
    },
  };
</script>
